var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewNcr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 89,
    viewBox: "0 0 85 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.0625 40.7336V73.0652C69.0625 75.1786 68.2229 77.2055 66.7285 78.6999C65.2341 80.1944 63.2072 81.0339 61.0937 81.0339H23.9062C21.7928 81.0339 19.7659 80.1944 18.2715 78.6999C16.7771 77.2055 15.9375 75.1786 15.9375 73.0652V19.9402C15.9375 17.8267 16.7771 15.7999 18.2715 14.3054C19.7659 12.811 21.7928 11.9714 23.9062 11.9714H40.3003C41.7088 11.9716 43.0595 12.5312 44.0556 13.527L67.5069 36.9784C68.5027 37.9744 69.0623 39.3252 69.0625 40.7336Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 13.2996V33.2214C42.5 34.6304 43.0597 35.9816 44.056 36.9779C45.0523 37.9742 46.4035 38.5339 47.8125 38.5339H67.7344",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2188 51.8147H55.7812",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2188 65.0969H55.7812",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.089 10.1173C45.526 15.6959 45.5866 24.8084 51.2241 30.4301C56.8616 36.0519 65.9742 36.0869 71.5373 30.5083C77.1003 24.9297 77.0397 15.8172 71.4022 10.1955C65.7647 4.57371 56.6521 4.53864 51.089 10.1173ZM65.98 17.2058L62.8757 20.3188L66.0216 23.4559C66.2302 23.6639 66.3484 23.9454 66.3504 24.2384C66.3523 24.5314 66.2378 24.812 66.032 25.0184C65.8261 25.2248 65.5459 25.3401 65.2529 25.339C64.9598 25.3379 64.678 25.2204 64.4694 25.0124L61.3235 21.8753L58.2192 24.9883C58.0134 25.1948 57.7331 25.3101 57.4401 25.309C57.1471 25.3078 56.8653 25.1903 56.6567 24.9823C56.4481 24.7743 56.3298 24.4929 56.3279 24.1998C56.3259 23.9068 56.4405 23.6262 56.6463 23.4198L59.7506 20.3068L56.6047 17.1697C56.3961 16.9617 56.2779 16.6802 56.2759 16.3872C56.274 16.0942 56.3885 15.8136 56.5943 15.6072C56.8002 15.4008 57.0804 15.2854 57.3735 15.2866C57.6665 15.2877 57.9483 15.4052 58.1569 15.6132L61.3028 18.7503L64.4071 15.6372C64.6129 15.4308 64.8932 15.3155 65.1862 15.3166C65.4792 15.3178 65.761 15.4352 65.9696 15.6433C66.1782 15.8513 66.2965 16.1327 66.2984 16.4258C66.3004 16.7188 66.1858 16.9994 65.98 17.2058Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNcr);
export default __webpack_public_path__ + "static/media/new-ncr.a0d7edb5b989ce2576e6efd06e145132.svg";
export { ForwardRef as ReactComponent };